module.exports = __webpack_public_path__ + "Getting_Started_Guide_VB.pdf";